import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL, ASSIGNMENT_GRID_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridModel, GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';

import { TrainersModel } from 'common/models/page-models/Trainers Model/trainers-data.model';
import { GridDataService } from '../base-data-services/grid-data.service';
import { StudentTrainerAssignmentGridParams, StudentTrainerAssignmentListingModel } from 'common/models/page-models/Student Trainer/student-trainer-assignment-grid.model';
import { AssignmentModel } from 'common/models/page-models/Assignments Model/assignment-data.model';

@Injectable({
  providedIn: 'root'
})
export class StudentTrainerAssignmentGridDataService extends GridDataService<StudentTrainerAssignmentListingModel, TrainersModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.studentTrainerAssignment, http, ss);

  }

  createInstance(): StudentTrainerAssignmentListingModel {
    return new StudentTrainerAssignmentListingModel();
  }

  override getDeleteUrl(): string {
    return '';
  }



  override getGridParams(param): GridPostParams {
    let params;
    params = new StudentTrainerAssignmentGridParams();
    // params.trainer_id = ;
    return params;
  }

  // override getExtraParam() {
  //   return 'trainer_detail';
  // }

  override getDataParam() {
    return 'details';
  }

  override modifyResponse(response: any) {
    // Check if response contains the details array
    if (response.details && response.details.length > 0) {
      response.details.forEach((detail) => {
        // Check if timeslot_info exists in the current detail object
        if (detail.timeslot_info && detail.timeslot_info.length > 0) {
          detail.timeslot_info.forEach((timeslot) => {
            // Concatenate start_date and end_date with a hyphen
            timeslot.date_range = `${timeslot.start_date} - ${timeslot.end_date}`;
            // console.log(timeslot.date_range, "date_range");
            detail.date_range = timeslot.date_range;
          });
        }
      });
    }

    return response;
  }

  override transformDataModel(data: any, param) {

    super.transformDataModel(data, 'details');
    // console.log(data,param);
    
    data[param].forEach((element) => {
      if (element.timeslot_info && element.timeslot_info.length > 0 && element.timeslot_info.start_date) {
        element.accepted = element.timeslot_info[0].accepted_student;
        element.timeslot_info = element.timeslot_info[0].start_date + ' - ' + element.timeslot_info[0].end_date;

        if (element.accepted === 0) {
          // console.log(element);
          
          element.accepted = 'N/A';
        }


      }
      if (element.non_accepted_student) {
        element.non_accepted_student === 0 ? 'N/A' : element.non_accepted_student;

      }
      if (element.invited_student) {
        element.invited_student === 0 ? 'N/A' : element.invited_student;
      }
      else {
        element.accepted = 'N/A';
        element.non_accepted_student = 'N/A';
        element.invited_student = 'N/A';
      }

    });
    // console.log();

    return data;

  }

  postLoginData(data, url: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.apiService
        .postData(url, data)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }


  //  override async createGridModel(apiRes: any, queryParam: GridParams, dataParam: string = 'details', extraParam: string = ''): Promise<any> {
  //     return await new Promise<any>((resolve, reject) => {
  //         const gridModel:any = new GridModel<any>();
  //     if (apiRes['header'].msg === "Data Not Found") {
  //         gridModel.extraData = queryParam
  //         gridModel.originalModel = [];
  //         gridModel.filterModel = [];
  //         gridModel.pageModel = [];
  //         gridModel.pages = [];
  //         resolve(gridModel);
  //         } else {
  //         super.createGridModel(apiRes, queryParam, dataParam, extraParam).then((data) => {
  //              data.extraData = queryParam
  //                 resolve(data)
  //             })
  //         }

  //     }).catch((error) => {
  //          return error
  //     });
  // }
}
